import React from 'react';
import Footer from '../../../layout/Footer/Footer';

const DefaultFooter = () => {
	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col-md-12'>
						<div className='text-end'>
							<span className='fw-light'>Copyright © 2024</span>
						</div>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
